module.exports = __webpack_public_path__ + "static/media/OpenSans-Regular.22ab03a6.ttf";